import styled from 'styled-components';
import Container from 'components/Container';
import { sizes } from 'style';
import { th } from 'style/theme';
import { ReactComponent as SafetyWingLogo } from 'products/global/assets/img/logos/SafetyWing.svg';
import Button from 'components/Button';

export const ClaimsContainer = styled(Container).attrs({ bg: 'orange' })`
  padding-top: 20px;
  min-height: calc(100vh - 110px);
  color: ${th('colors.black')};

  @media ${sizes.desktop} {
    padding-top: 50px;
  }
`;

export const MobileButton = styled(Button)`
  padding: 9px 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  > svg {
    font-size: 14px;
  }

  @media ${sizes.mobileLarge} {
    display: none;
  }
`;

export const DesktopButton = styled(Button)`
  padding: 9px 28px;
  align-items: center;
  gap: 5px;
  display: none;

  > svg {
    font-size: 14px;
  }

  @media ${sizes.mobileLarge} {
    display: flex;
  }
`;

export const ClaimsNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  height: 72px;
  background-color: white;
  padding: 16px 28px;
  font-weight: 500;
`;

export const Logo = styled(SafetyWingLogo)`
  height: 24px;
  width: auto;
`;
